import ComponentOverview from './ComponentOverview';

export default ComponentOverview;
